{
  "es": {
    "choice": {
      "actions": {
        "delete_choice": "Eliminar opción",
        "delete_choice_list": "Eliminar lista de opciones"
      },
      "labels": {
        "not_selected": "No seleccionada",
        "selected": "Seleccionada"
      },
      "messages": {
        "delete_choice": "¿Seguro que quieres eliminar la opción {title}?",
        "delete_choice_list": "¿Seguro que quieres eliminar la lista de opciones {title}?"
      },
      "toasts": {
        "create": "Opción creada correctamente",
        "delete": "Opción eliminada correctamente",
        "update": "Opción actualizada correctamente"
      }
    }
  }
}
